import { render, staticRenderFns } from "./NewStepItem.vue?vue&type=template&id=2b16c2db&scoped=true"
import script from "./NewStepItem.vue?vue&type=script&lang=js"
export * from "./NewStepItem.vue?vue&type=script&lang=js"
import style0 from "./NewStepItem.vue?vue&type=style&index=0&id=2b16c2db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b16c2db",
  null
  
)

export default component.exports